import { filter } from 'lodash';
import { HeaderMainFooterLayout } from '@/modules/base';
import {
  FooterComponent,
  NavigationComponent,
  ShopCartConfirmationModal,
  ShopCartContactFormComponent,
  ShopCartItemsTable,
} from '@/modules/components';
import React from 'react';
import { useInteractionState } from '@/hooks';
import { MenuItem } from '@/type';

export const ShopCartComponent = () => {
  const { menus } = useInteractionState();

  const cartMenus = filter(menus, (it: MenuItem) => it.used_in_cart);
  const reference = (Math.random() * 10e16).toString(36);

  return (
    <HeaderMainFooterLayout
      header={<NavigationComponent menuItems={cartMenus} />}
      main={
        <section id="cart" className="cart">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <ShopCartItemsTable />
                <div className="line" />
                <ShopCartContactFormComponent />
              </div>
            </div>
          </div>
          <ShopCartConfirmationModal reference={reference} />
        </section>
      }
      footer={<FooterComponent />}
    />
  );
};
